var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationJuice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8447 23.5H14.9902V26.1H17.8447V23.5Z",
    fill: "#176318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42726 17.0001H9.98113L10.709 20.7961L7.92588 28.2841C7.85325 28.48 7.83295 28.6887 7.86665 28.8932C7.90035 29.0976 7.98708 29.2917 8.11965 29.4595C8.25222 29.6273 8.4268 29.7638 8.62891 29.8579C8.83102 29.9519 9.05483 30.0006 9.28177 30.0001H23.5543C23.7813 30.0006 24.0051 29.9519 24.2072 29.8579C24.4093 29.7638 24.5839 29.6273 24.7165 29.4595C24.849 29.2917 24.9358 29.0976 24.9695 28.8932C25.0032 28.6887 24.9829 28.48 24.9102 28.2841L22.1271 20.7961L24.9816 5.50811C25.0149 5.32082 25.0029 5.12915 24.9462 4.94656C24.8896 4.76397 24.7898 4.59489 24.6538 4.45118C24.5177 4.30747 24.3488 4.19262 24.1589 4.1147C23.969 4.03677 23.7626 3.99766 23.5543 4.00011H9.28177C9.07348 3.99766 8.86712 4.03677 8.67719 4.1147C8.48726 4.19262 8.31836 4.30747 8.18234 4.45118C8.04633 4.59489 7.9465 4.76397 7.88987 4.94656C7.83323 5.12915 7.82117 5.32082 7.85451 5.50811L8.31124 7.90011H6.42726C6.04872 7.90011 5.6857 8.03707 5.41803 8.28087C5.15037 8.52467 5 8.85533 5 9.20011V15.7001C5 16.0449 5.15037 16.3755 5.41803 16.6193C5.6857 16.8631 6.04872 17.0001 6.42726 17.0001ZM11.2657 27.4001L13.1639 22.2001H19.6722L21.5705 27.4001H11.2657ZM21.8702 6.60011L19.4867 19.6001H13.3495L10.9659 6.60011H21.8702ZM7.85451 10.5001H8.78223L9.49586 14.4001H7.85451V10.5001Z",
    fill: "#176318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationJuice);
export default __webpack_public_path__ + "static/media/OperationJuice.f54f8fab29f5a839594f24c7b2b049e3.svg";
export { ForwardRef as ReactComponent };